import { IResourceCategory } from '../../types/resourceCategory'

export interface ICategoryOption {
  value: string
  label: string
}

// Agrupa la lista plana de categorías por parentId (null = raíces)
export const buildCategoryChildrenMap = (
  categories: IResourceCategory[]
): Map<string | null, IResourceCategory[]> => {
  const map = new Map<string | null, IResourceCategory[]>()
  categories.forEach((category) => {
    const parentId = category.parent?.id ?? null
    const siblings = map.get(parentId) || []
    siblings.push(category)
    map.set(parentId, siblings)
  })
  return map
}

// Aplana el árbol en opciones para react-select con labels indentados por profundidad
export const flattenCategoryTree = (
  categories: IResourceCategory[],
  excludeId?: string
): ICategoryOption[] => {
  const childrenMap = buildCategoryChildrenMap(categories)
  const options: ICategoryOption[] = []

  const walk = (parentId: string | null, depth: number) => {
    const children = childrenMap.get(parentId) || []
    children.forEach((category) => {
      // Excluir una categoría y todo su subárbol (para evitar ciclos al mover)
      if (excludeId && category.id === excludeId) return
      options.push({
        value: category.id,
        label: `${'— '.repeat(depth)}${category.name}`,
      })
      walk(category.id, depth + 1)
    })
  }

  walk(null, 0)
  return options
}

// Devuelve la ruta desde la raíz hasta la categoría (para breadcrumbs)
export const getCategoryPath = (
  categories: IResourceCategory[],
  categoryId: string | null
): IResourceCategory[] => {
  if (!categoryId) return []
  const byId = new Map(categories.map((c) => [c.id, c]))
  const path: IResourceCategory[] = []
  let current = byId.get(categoryId)
  while (current) {
    path.unshift(current)
    current = current.parent?.id ? byId.get(current.parent.id) : undefined
  }
  return path
}
